import { useState } from "react";
import { Page, useCurrent } from "./common";
import { PageHead, Avatar, Seg, Empty } from "../components/ui";
import { Icon } from "../components/Icons";
import { actions } from "../lib/store";
import { useCan } from "../lib/auth";
import { relative } from "../lib/format";

export default function Feedback() {
  const p = useCurrent();
  const canEdit = useCan("feedback");
  const [filter, setFilter] = useState<"open" | "all" | "resolved">("open");
  const [reply, setReply] = useState<Record<string, string>>({});
  if (!p) return null;

  const items = p.feedback.filter((f) => filter === "all" ? true : filter === "open" ? !f.resolved : f.resolved);

  function send(fid: string) {
    const body = (reply[fid] ?? "").trim();
    if (!body) return;
    actions.replyFeedback(p!.id, fid, "studio", "Studio", body);
    setReply((r) => ({ ...r, [fid]: "" }));
  }

  return (
    <Page max={860}>
      <PageHead kicker={`${p.name} · Client dialogue`} title="Feedback">
        <Seg value={filter} onChange={setFilter} options={[{ value: "open", label: "Open" }, { value: "resolved", label: "Resolved" }, { value: "all", label: "All" }]} />
      </PageHead>

      {items.length === 0 && <Empty>Nothing here — you're all caught up.</Empty>}

      <div className="col" style={{ gap: 16 }}>
        {items.map((f) => (
          <div key={f.id} className="card pad reveal" style={{ borderColor: f.resolved ? "var(--line)" : "color-mix(in srgb, var(--accent) 30%, var(--line))" }}>
            <div className="row between" style={{ marginBottom: 12 }}>
              <div className="row" style={{ gap: 12 }}>
                <Avatar name={f.authorName} hue={p.client.avatarHue} size={38} />
                <div>
                  <div style={{ fontWeight: 600 }}>{f.authorName}</div>
                  <div className="row" style={{ gap: 8 }}><span className="badge accent" style={{ fontSize: 10 }}>{f.context}</span><span className="dim" style={{ fontSize: 12 }}>{relative(f.createdOn)}</span></div>
                </div>
              </div>
              {canEdit && <button className="chip" onClick={() => actions.resolveFeedback(p.id, f.id)}>{f.resolved ? "Reopen" : "Resolve"}</button>}
            </div>

            <p style={{ fontSize: 15.5, lineHeight: 1.6 }}>{f.body}</p>

            {f.replies.length > 0 && (
              <div className="col" style={{ gap: 10, marginTop: 14, paddingLeft: 14, borderLeft: "2px solid var(--line)" }}>
                {f.replies.map((r) => (
                  <div key={r.id}>
                    <div className="row" style={{ gap: 8, marginBottom: 3 }}><span style={{ fontWeight: 600, fontSize: 13 }}>{r.authorName}</span><span className="dim" style={{ fontSize: 11.5 }}>{relative(r.createdOn)}</span></div>
                    <p className="muted" style={{ fontSize: 14 }}>{r.body}</p>
                  </div>
                ))}
              </div>
            )}

            {canEdit && !f.resolved && (
              <div className="row" style={{ gap: 10, marginTop: 14 }}>
                <input className="input" placeholder="Reply to the client…" value={reply[f.id] ?? ""} onChange={(e) => setReply((r) => ({ ...r, [f.id]: e.target.value }))} onKeyDown={(e) => e.key === "Enter" && send(f.id)} />
                <button className="btn accent" onClick={() => send(f.id)}><Icon.send width={15} /></button>
              </div>
            )}
          </div>
        ))}
      </div>
    </Page>
  );
}
